import { render, staticRenderFns } from "./WhyArmy.vue?vue&type=template&id=f830e644&scoped=true&lang=pug&"
import script from "./WhyArmy.vue?vue&type=script&lang=js&"
export * from "./WhyArmy.vue?vue&type=script&lang=js&"
import style0 from "./WhyArmy.vue?vue&type=style&index=0&id=f830e644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f830e644",
  null
  
)

export default component.exports